module.exports = __webpack_public_path__ + "img/编组 6.19879b1b.png";